import { render, staticRenderFns } from "./TaskTypeNameInput.vue?vue&type=template&id=db618d3e&"
import script from "./TaskTypeNameInput.vue?vue&type=script&lang=ts&"
export * from "./TaskTypeNameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports